import React from 'react';
import { colors } from '@styleseat/brand';

type VariousToolTipRootIconProps = {
  width?: number;
  height?: number;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const VariousToolTipRootIcon = ({
  width = 24,
  height = 7,
  color = colors.purple,
}: VariousToolTipRootIconProps) => (
  <svg width={width} height={height} viewBox="0 0 24 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 1.99989C12 4 12 7 12 7C12 7 12 3.99979 8 1.99989C4 0 0 0 0 0H24C24 0 20 -0.000212669 16 1.99989Z" fill={color} />
  </svg>
);
